import './TopActionBar.css';

interface TopActionBarProps {
    breadcrumbs: string[];
}

export default function TopActionBar({ breadcrumbs }: TopActionBarProps) {
    return (
        <div className="action-bar">
            {/* Breadcrumbs */}
            <nav className="action-bar__breadcrumbs" aria-label="Breadcrumbs">
                {breadcrumbs.map((crumb, i) => (
                    <span key={i} className="action-bar__crumb">
                        {i > 0 && (
                            <svg className="action-bar__separator" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        )}
                        <span className={i === breadcrumbs.length - 1 ? 'action-bar__crumb--current' : ''}>{crumb}</span>
                    </span>
                ))}
            </nav>
        </div>
    );
}
